export const SummaryCards = ({ tabs, tab, summary, onSelect }) => (
  <div className="mt-8 grid gap-4 sm:grid-cols-2" data-testid="admin-summary">
    {tabs.map((t) => (
      <button key={t.id} type="button" onClick={() => onSelect(t.id)} className={`card p-5 text-left ${tab === t.id ? "border-blue/70" : ""}`} data-testid={`admin-tab-${t.id}`}>
        <div className="flex items-center gap-2 text-sm text-muted"><t.icon size={16} className="text-blue-text" /> {t.label}</div>
        <p className="mt-2 text-3xl font-semibold tracking-tight text-body" data-testid={`admin-count-${t.id}`}>{summary ? summary[t.id] : "—"}</p>
      </button>
    ))}
  </div>
);
